import { matchPath } from 'react-router-dom';
import { Route } from 'app/routing/routesConfig';

export const isPageView = <T extends string>(route: Route) => {
  const isHashRouting = Boolean(window.location.hash);
  const currentPath = isHashRouting
    ? window.location.hash.slice(1)
    : window.location.pathname.replace('/studio', '');

  return matchPath<T, string>(route?.matchPattern || route.path, currentPath);
};
